module.exports = __webpack_public_path__ + "img/kyrgyzstan.09cc2766.png";